<template>
	<button
		:aria-label="translations['Favorites']"
		class="c-favorite"
		:class="[{ 'c-favorite--active': isFavorite() }, 'c-favorite--' + version]"
		@click.stop.prevent="setFavorite()"
	>
		<FavoriteIcon v-if="version == 'icon'"></FavoriteIcon>
		<div v-if="version == 'inline'">
			<span v-if="isFavorite()">{{
				translations["Remove from favorites"]
			}}</span>
			<span v-else>{{ translations["Add to favorites"] }}</span>
		</div>
	</button>
</template>

<script>
import FavoriteIcon from "@web/assets/icon/favorite.svg";
import request from "@/vue/mixins/request.js";
import * as map from "@/vue/mixins/map";

export default {
	name: "Favorite",
	mixins: [map.site, request],
	components: {
		FavoriteIcon,
	},
	props: {
		id: Number,
		version: {
			type: String,
			default: "icon",
		},
	},
	methods: {
		isFavorite() {
			if (!this.favorites) {
				return false;
			}

			if (this.favorites?.ids?.includes(parseInt(this.id))) {
				return true;
			}
			return false;
		},

		setFavorite() {
			if (!this.id) {
				return;
			}

			const formData = new FormData();
			formData.append("action", this.action.favorite);
			formData.append("productId", this.id);

			this.request(formData).then(() => {
				if (this.res.data.success) {
					this.$store.dispatch("app/favorites", this.res.data.favorites);
				}
			});
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-favorite {
	width: 38px;
	height: 38px;
	background-color: $c-white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	cursor: pointer;

	svg {
		fill: $c-white;
		transition: $t-hover;

		width: 22px;
		height: 22px;
	}

	&--inline {
		width: fit-content;
		height: fit-content;
	}

	&--active,
	&:hover {
		svg {
			transition: $t-hover;
			fill: $c-blue;
		}
	}
}
</style>
